import React, { useState, useEffect, Suspense } from 'react';
import { useGlobal } from  "reactn";
import { BrowserRouter as Router, Switch, Route, Link, Redirect } from "react-router-dom";
import { useAuth } from 'stores/auth';
import { useApi } from 'stores/api';

import ScrollToTop from 'components/ScrollToTop';
import SiteHeader from 'components/SiteHeader';
import SiteFooter from 'components/SiteFooter';
import Modal from 'components/Modal';
import Loader from 'components/Loader';

import Home from 'pages/Home';
import Search from 'pages/Search';
import ObjectDetails from 'pages/ObjectDetails';
import BWBookingData from 'pages/bookingwizard/BWBookingData';
import BWOptions from 'pages/bookingwizard/BWOptions';
import BWPersonalData from 'pages/bookingwizard/BWPersonalData';
import BWOverview from 'pages/bookingwizard/BWOverview';
import BWPayment from 'pages/bookingwizard/BWPayment';
import BWConfirmation from 'pages/bookingwizard/BWConfirmation';
import UserProfile from 'pages/user/UserProfile';
import Bookings from 'pages/user/Bookings';
import BookingDetails from 'pages/user/BookingDetails';
import ConfirmRegistration from 'pages/user/public/ConfirmRegistration';
import ForgotPassword from 'pages/user/public/ForgotPassword';
import ResetPassword from 'pages/user/public/ResetPassword';
import NoMatch from 'pages/NoMatch';

import 'components/SlideDown.css';
//import 'swiper/swiper-bundle.min.css';
import 'App.css';


function App() {
  const auth = useAuth();
  const api = useApi();
  const [masterData] = useGlobal("masterData");
  const [modalProps] = useGlobal("modalProps");
  const [lessorId, setLessorId] = useState('');

  useEffect(() => {
    async function onInit() {
      if (!masterData) {
        await api.fetchMasterData();
      }
      auth.initLogin();
    }
    setLessorId(document.location.pathname.split('/')[2]);
    onInit();
  }, []);

  return (
    !masterData ? <Loader /> :
      <div className="App">
        <Suspense fallback={<Loader />}>
          <Router basename={`/lessors/${lessorId}`}>
            <ScrollToTop />
            <SiteHeader />
            <Switch>
              <Route exact path="/">
                <Home />
              </Route>
              <Route path="/search">
                <Search />
              </Route>
              <Route path="/objectdetails/:objectId">
                <ObjectDetails />
              </Route>

              <Route exact path="/register">
                <UserProfile isRegistration={true} />
              </Route>
              <Route path="/registration/confirm">
                <ConfirmRegistration />
              </Route>              
              <Route path="/forgotpassword">
                <ForgotPassword />
              </Route>                          
              <Route path="/resetpassword">
                <ResetPassword />
              </Route>


              <Route path="/wizard/book/:objectId">
                <BWBookingData />
              </Route>
              <Route path="/wizard/options/:action">
                <BWOptions />
              </Route>
              <Route path="/wizard/personaldata/:action?">
                <BWPersonalData />
              </Route>
              <Route path="/wizard/overview">
                <BWOverview />
              </Route>
              <Route path="/wizard/payment">
                <BWPayment />
              </Route>
              <Route path="/wizard/confirmation">
                <BWConfirmation />
              </Route>

              <Route path="/user/profile">
                {auth.user ? <UserProfile isRegistration={false} /> : <Redirect to="/" />}
              </Route>
              <Route path="/user/bookings">
                <Bookings />
              </Route>
              <Route path="/user/bookingdetails/:bookingId">
                <BookingDetails />
              </Route>

              <Route path="*">
                <NoMatch />
              </Route>
            </Switch>
            <SiteFooter />
            <Modal></Modal>
          </Router>
        </Suspense>
      </div>
  );
}

export default App;
